<template>
  <FloatingView
    :is-expanded="isExpanded"
    :data-e2e="InAppAnnouncementCypressAttribute.views.IN_APP_ANNOUNCEMENT"
  >
    <template #title>
      <div class="is-flex has-gap-10">
        <i class="is-size-3 cls cls-magic-stars has-text-primary" />
        <p class="has-text-primary is-size-6 is-uppercase has-text-weight-semibold">
          {{ $t('announcementmodal.title') }}
        </p>
      </div>
    </template>
    <template #content="{ isExpanded }">
      <CarouselView
        :autoplay="false"
        :indicator="hasMultipleAnnouncements"
        :arrow="hasMultipleAnnouncements"
        :repeat="false"
        class="is-flex is-full-height"
        icon-pack="cls"
        icon-prev="cls-caret-left"
        icon-next="cls-caret-right"
        :data-e2e="InAppAnnouncementCypressAttribute.views.CAROUSEL"
      >
        <CarouselItemView
          class="p-l-5 p-r-5 is-overflow-y-auto"
          v-for="announcement in announcements"
          :key="announcement.id"
        >
          <template #body>
            <InAppAnnouncementDetails :announcement="announcement" :is-expanded="isExpanded" />
          </template>
        </CarouselItemView>
      </CarouselView>
    </template>
    <template #footer>
      <div class="is-flex is-align-items-center is-justify-content-flex-end has-gap-10">
        <ButtonView
          type="button"
          class="button is-primary is-light has-text-weight-semibold"
          @click="openReleaseUpdatesFn"
          :data-e2e="InAppAnnouncementCypressAttribute.buttons.OPEN_RELEASE_UPDATES"
        >
          {{ $t('announcementmodal.open-release-updates') }}
        </ButtonView>
        <ButtonView
          type="button"
          class="button has-text-primary has-border-primary has-text-weight-semibold"
          @click="gotItFn"
          :data-e2e="InAppAnnouncementCypressAttribute.buttons.GOT_IT"
        >
          {{ $t('announcementmodal.got-it') }}
        </ButtonView>
      </div>
    </template>
  </FloatingView>
</template>

<script>
import FloatingView from '@/modules/core/app/components/FloatingView.vue';
import { AnnouncementContentType } from '@/modules/announcement/constants/AnnouncementContentType';
import { InAppAnnouncementCypressAttribute } from '@/modules/announcement/constants/InAppAnnouncementCypressAttribute';
import { DateFormat } from '/@/modules/core/app/constants/date.constants';
import InAppAnnouncementDetails from '@/modules/announcement/components/stateful/InAppAnnouncementDetails.vue';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';
import CarouselView from '@/modules/core/ui/components/wrappers/CarouselView.vue';
import CarouselItemView from '@/modules/core/ui/components/wrappers/CarouselItemView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'InAppAnnouncement',
  components: {
    ButtonView,
    FloatingView,
    InAppAnnouncementDetails,
    CarouselView,
    CarouselItemView
  },
  props: {
    announcements: {
      type: Array,
      default: () => []
    },
    gotItFn: {
      type: Function,
      default: () => {}
    },
    openReleaseUpdatesFn: {
      type: Function,
      default: () => {}
    },
    isExpanded: {
      type: Boolean,
      default: false
    }
  },
  static: {
    AnnouncementContentType,
    InAppAnnouncementCypressAttribute,
    DateFormat
  },
  computed: {
    hasMultipleAnnouncements() {
      return this.announcements.length > 1;
    }
  }
};
</script>

<style scoped>
:deep(.carousel-arrow .icon) {
  background: #7e84a34d;
  color: #7e84a3;
  border: none;
}

:deep(.carousel .carousel-indicator .indicator-item .indicator-style) {
  background: #7e84a34d;
  border: none;
}

:deep(.carousel .carousel-indicator .indicator-item.is-active .indicator-style) {
  background: #7e84a3;
  border: var(--ce-4px) solid #7e84a34d;
}
</style>
